import { RouteRecordRaw } from 'vue-router';
import { PRODUCT_ROUTE_NAME } from '@/libs/route-name';

export const categoryRoute = (): RouteRecordRaw => ({
    path: '/manage/category',
    name: PRODUCT_ROUTE_NAME.CATEGORY,
    component: () => import('@/pages/product/category.vue'),
});